module.exports = __webpack_public_path__ + "img/abyssus01.c8fd642b.jpg";